import React, { useState } from "react";
import { toast } from "sonner";
import { FileText, Activity, Table, Stethoscope, Download, Lock, Mail, ShieldCheck } from "lucide-react";
import AppLayout from "../components/AppLayout";
import { DOWNLOADS, gbp } from "../data";
import { useAsaAuth } from "../AuthContext";
import { startDownloadCheckout } from "../payments";

const iconMap = { FileText, Activity, Table, Stethoscope };

export default function Reports() {
  const { user } = useAsaAuth();
  const [loadingId, setLoadingId] = useState(null);

  const buy = async (d) => {
    setLoadingId(d.id);
    try {
      await startDownloadCheckout({ downloadId: d.id, title: d.title, email: user?.email, returnTo: "/asa/reports" });
    } catch (e) {
      setLoadingId(null);
      toast.error("Could not start checkout. Please try again.");
    }
  };

  return (
    <AppLayout title="Reports & Tools">
      <div className="flex items-start gap-2 bg-[#e6f4f2] border border-[#c9e9e4] rounded-xl p-4 mb-5">
        <Lock size={18} className="text-[#0d9488] shrink-0 mt-0.5" />
        <p className="text-[13px] text-slate-600">Diagnostic tools and GP/Doctor reports are <strong>charged per download</strong>. Each purchase helps fund the ASA Foundation.</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        {DOWNLOADS.map((d) => {
          const Icon = iconMap[d.icon] || FileText;
          return (
            <div key={d.id} className="bg-white rounded-2xl border border-slate-200 p-5 flex flex-col">
              <div className="flex items-start gap-3">
                <div className="w-12 h-12 rounded-xl bg-[#e6f4f2] text-[#0d9488] flex items-center justify-center shrink-0"><Icon size={24} /></div>
                <div>
                  <h3 className="font-head font-semibold text-slate-800">{d.title}</h3>
                  <p className="text-[13.5px] text-slate-500 mt-1 leading-relaxed">{d.desc}</p>
                </div>
              </div>
              <div className="flex items-center justify-between mt-5 pt-4 border-t border-slate-100">
                <span className="text-lg font-head font-bold text-slate-800">{gbp(d.price)} <span className="text-[12px] font-normal text-slate-400">per download</span></span>
                <button onClick={() => buy(d)} disabled={loadingId === d.id} className="inline-flex items-center gap-2 h-10 px-4 rounded-lg bg-[#0d9488] hover:bg-[#0f766e] disabled:opacity-60 text-white font-semibold text-sm transition-colors"><Download size={16} /> {loadingId === d.id ? "Redirecting…" : "Buy & download"}</button>
              </div>
            </div>
          );
        })}
      </div>

      <p className="text-[12px] text-slate-400 flex items-center gap-1.5 mt-6"><ShieldCheck size={13} /> Reports you generate are stored securely in your ASAL account. © ASA Foundation · Copyright &amp; IP: Asal Shirazi.</p>
    </AppLayout>
  );
}
